import { useTranslation } from 'react-i18next'
import logo_inducontrol from 'assets/images/logos/ic-suite-logo-64x64.png'

export const LogoLlargInducontrol = () => {
  const { t } = useTranslation()
  return (
    <a className="text-decoration-none text-black" href="https://inducontrol.com/es/">
      <div className="rounded px-2 py-1 d-inline-block" style={{ backgroundColor: 'white' }}>
        <div className="d-flex align-items-center gap-2">
          <div>
            <img alt="ICSuite" src={logo_inducontrol} height="42px" width="42px" />
          </div>
          <div className="d-flex flex-column justify-content-end">
            <h6 style={{ fontFamily: 'Graphik-semibold' }} className="text-black mb-0">
              {t('catalog').toUpperCase()}
            </h6>
            <small style={{ fontFamily: 'Graphik-regular' }}>by Inducontrol</small>
          </div>
        </div>
      </div>
    </a>
  )
}

export const LogoInduControl = () => {
  return (
    <span className="bg-white p-2 rounded">
      <img alt="ICSuite" src={logo_inducontrol} height="36px" width="36px" />
    </span>
  )
}
